import { makeStyles } from "@mui/styles";
import { primaryColor, secondaryColor } from "../../constants/colors";

const dynamicTableStyle = makeStyles((theme) => ({
  statusSwitchOn: {
    "&.MuiSwitch-root .MuiSwitch-switchBase": {
      color: primaryColor,
    },
    "&.MuiSwitch-root .MuiSwitch-track": {
      background: primaryColor,
    },
  },
  restSwitch: {
    "&.MuiFormControlLabel-root .MuiSwitch-root .MuiSwitch-track": {
      backgroundColor: primaryColor,
    },
    "&.MuiFormControlLabel-root .MuiSwitch-root .MuiSwitch-switchBase": {
      color: primaryColor,
    },
    "&.MuiFormControlLabel-root": {
      marginTop: "15px",
      marginLeft: "13px",
    },
  },
}));

export default dynamicTableStyle;
